export { APIRoutes, type IAPIRoutes } from "./apiRoutes";

const env = import.meta.env;

export const amplifyConfigData = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID,
    authenticationFlowType: "CUSTOM_AUTH",
  },
  Storage: {
    AWSS3: {
      bucket: env.VITE_S3_BUCKET,
      region: env.VITE_AWS_REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: env.VITE_API_NAME,
        endpoint: env.VITE_API_GATEWAY_URL,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_TRACKING_GATEWAY_SERVICE,
        endpoint: env.VITE_TRACKING_GATEWAY_URL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL,
        endpoint: env.VITE_API_GATEWAY_URL_CDL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL_DEV,
        endpoint: env.VITE_API_GATEWAY_URL_CDL_DEV,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
};

export const amplifyConfigDataNewSetUp = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: env.VITE_S3_BUCKET,
      region: env.VITE_AWS_REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: env.VITE_API_NAME,
        endpoint: env.VITE_API_GATEWAY_URL_V2,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_TRACKING_GATEWAY_SERVICE,
        endpoint: env.VITE_TRACKING_GATEWAY_URL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL,
        endpoint: env.VITE_API_GATEWAY_URL_CDL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL_DEV,
        endpoint: env.VITE_API_GATEWAY_URL_CDL_DEV,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
};

export const amplifyGoConfigData = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID,
  },
  Storage: {
    AWSS3: {
      bucket: env.VITE_S3_BUCKET,
      region: env.VITE_AWS_REGION,
    },
  },
  API: {
    endpoints: [
      {
        name: env.VITE_API_NAME,
        endpoint: env.VITE_API_GATEWAY_URL_G0,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_TRACKING_GATEWAY_SERVICE,
        endpoint: env.VITE_TRACKING_GATEWAY_URL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL,
        endpoint: env.VITE_API_GATEWAY_URL_CDL,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
      {
        name: env.VITE_API_NAME_CDL_DEV,
        endpoint: env.VITE_API_GATEWAY_URL_CDL_DEV,
        service: env.VITE_TRACKING_GATEWAY_SERVICE,
        region: env.VITE_AWS_REGION,
      },
    ],
  },
  Analytics: {
    disabled: true,
  },
};

export const amplifySSOConfigData = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID_SSO,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID_SSO,
  },
  Analytics: {
    disabled: true,
  },
};
export const amplifyZpaxSSOConfigData = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID_SSO_ZPAX,
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID_SSO_ZPAX,
  },
  Analytics: {
    disabled: true,
  },
};

// Microsoft SSO uses the main identity pool with a dedicated app client
export const amplifyMicrosoftSSOConfigData = {
  Auth: {
    mandatorySignIn: true,
    region: env.VITE_AWS_REGION,
    userPoolId: env.VITE_COGNITO_USER_POOL_ID,
    identityPoolId: env.VITE_COGNITO_IDENTITY_POOL_ID_MICROSOFT, // Microsoft identity pool
    userPoolWebClientId: env.VITE_COGNITO_APP_CLIENT_ID_SSO_MICROSOFT, // Microsoft SSO app client
  },
  Analytics: {
    disabled: true,
  },
};

export const apiOrigin = env.VITE_API_GATEWAY_URL_V2;
const normalizeBaseUrl = (baseUrl: string, path: string) => {
  const trimmedBase = baseUrl.replace(/\/+$/, "");
  const trimmedPath = path.replace(/^\/+/, "");
  return `${trimmedBase}/${trimmedPath}`;
};
const defaultAuthOrigin = apiOrigin.endsWith("/patient-centric-app-v2")
  ? apiOrigin
  : normalizeBaseUrl(apiOrigin, "/patient-centric-app-v2");
export const authApiOrigin = env.VITE_AUTH_API_ORIGIN
  ? normalizeBaseUrl(env.VITE_AUTH_API_ORIGIN, "/patient-centric-app-v2")
  : defaultAuthOrigin;

export const apiName = env.VITE_API_NAME;
export const apiNameCDL = env.VITE_API_NAME_CDL;
export const apiNameCDLDev = env.VITE_API_NAME_CDL_DEV;

export const amchartLicenseKey = env.VITE_AMCHART_LICENSE_KEY;

// Microsoft SSO / MSAL configuration
export const compassusMicrosoftTenantId =
  env.VITE_COMPASSUS_MICROSOFT_TENANT_ID;
export const compassusMicrosoftClientIdForOutlook =
  env.VITE_COMPASSUS_MICROSOFT_CLIENT_ID_FOR_OUTLOOK;

export type IAmplifyConfigData = typeof amplifyConfigData;
export type IAmplifyConfigDataNewSetUp = typeof amplifyConfigDataNewSetUp;
export type IAmplifyGoConfigData = typeof amplifyGoConfigData;
export type IAmplifySSOConfigData = typeof amplifySSOConfigData;
export type IAmplifyZpaxSSOConfigData = typeof amplifyZpaxSSOConfigData;
export type IAmplifyMicrosoftSSOConfigData =
  typeof amplifyMicrosoftSSOConfigData;
